exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sokal-hp-component-hero-section[data-v-2bf7394c]{margin-top:14em;margin-bottom:8em}.sokal-hp-component-hero-section .sokal-bg-cover[data-v-2bf7394c]{-webkit-backdrop-filter:blur(13px);backdrop-filter:blur(13px)}.sokal-hp-component-hero-section .sokal-media-container[data-v-2bf7394c]{padding-top:50%}@media (min-width:768px){.sokal-hp-component-hero-section .sokal-media-container[data-v-2bf7394c]{padding-top:28%}}", ""]);

// exports
